import { CheckboxGroupButtons } from '@/components/_common';
import {
  ReportType,
  Situation,
} from '@/core/domain/reports/financial/billsToReceive/billsToReceive.types';
import { Col, Form, Radio, Row, Typography } from 'antd';
import { useIntl } from 'react-intl';

const BillsToReceiveRadios = () => {
  const intl = useIntl();
  const { Title } = Typography;

  const situationOptions = [
    {
      value: Situation.open,
      label: intl.formatMessage({
        id: 'financial.billsToReceive.form.situation.open',
      }),
    },
    {
      value: Situation.liquidated,
      label: intl.formatMessage({
        id: 'financial.billsToReceive.form.situation.liquidated',
      }),
    },
  ];

  return (
    <Row>
      <Col xs={24}>
        <Title level={5}>
          {intl.formatMessage({
            id: 'financial.billsToReceive.form.situation',
          })}
        </Title>
        <Form.Item name="lsSituacao" initialValue={[Situation.open]}>
          <CheckboxGroupButtons options={situationOptions} />
        </Form.Item>
      </Col>

      <Col xs={24}>
        <Title level={5}>
          {intl.formatMessage({
            id: 'financial.billsToReceive.form.reportType',
          })}
        </Title>
        <Form.Item name="reportType" initialValue={ReportType.maturity}>
          <Radio.Group optionType="button" buttonStyle="solid" size="large">
            <Radio value={ReportType.issue}>
              {intl.formatMessage({
                id: 'financial.billsToReceive.form.reportType.issue',
              })}
            </Radio>
            <Radio value={ReportType.maturity}>
              {intl.formatMessage({
                id: 'financial.billsToReceive.form.reportType.maturity',
              })}
            </Radio>
            <Radio value={ReportType.receipt}>
              {intl.formatMessage({
                id: 'financial.billsToReceive.form.reportType.receipt',
              })}
            </Radio>
            <Radio value={ReportType.chartOfAccounts}>
              {intl.formatMessage({
                id: 'financial.billsToReceive.form.reportType.chartOfAccounts',
              })}
            </Radio>
          </Radio.Group>
        </Form.Item>
      </Col>
    </Row>
  );
};
export default BillsToReceiveRadios;
